const EXIT_INTENT_FIELD = 'exit_intent';

export function markAsOpened() {
  sessionStorage.setItem(EXIT_INTENT_FIELD, true);
}

export function wasOpened() {
  const item = sessionStorage.getItem(EXIT_INTENT_FIELD);

  return item && JSON.parse(item);
}
